import {NavTheme} from 'epic-games-nav-shared';
import {useCurrentAccentColor, edsPalette} from 'epic-ue-theme';
import {getLocale} from '@epic-core/common';

export const getNavTheme = (): NavTheme => {
    let ueH4Font = 'Inter,monospace';
    switch (getLocale()) {
        case 'ja':
            ueH4Font = 'Noto Sans JP, Noto-Regular, sans-serif';
            break;
        case 'ko':
            ueH4Font = 'Noto Sans KR, Noto-Regular, sans-serif';
            break;
        case 'zh-CN':
            ueH4Font = 'Noto Sans SC, Noto-Regular, sans-serif';
            break;
        default:
            break;
    }

    const palette = {
        text: {
            primary: '#e6e6ea',
            secondary: '#aaaaae',
            eyebrow: '#aaaaae',
            primaryHover: '#fff'
        },
        background: {
            default: edsPalette.background.elevated.low,
            paper: edsPalette.background.elevated.high.default
        },
        border: '#303034',
        accent: {
            text: '#26bbff',
            background: 'radial-gradient(100% 185.14% at 100% 100%, #34C3FF 0%, #338EEE 100%)',
            backgroundHover: '#338EEE',
            backgroundText: '#000',
            backgroundTextHover: '#000'
        }
    };

    return {
        forwardIcon: 'arrow-forward',
        palette,
        fonts: {
            default: 'Inter,sans-serif,arial',
            heading2: 'Inter,Open Sans,arial',
            heading3: 'Inter,Open Sans,arial',
            heading4: ueH4Font,
            paragraph: 'Inter,Open Sans,arial'
        }
    };
};

export const useNavTheme = (pathname: string, isFooter?: boolean): NavTheme => {
    const {color, from, to} = useCurrentAccentColor();
    const navTheme = getNavTheme();

    // don't modify the original object, use a clone
    const theme = {
        ...navTheme,
        logo: {
            ...navTheme.logo
        },
        palette: {
            ...navTheme.palette
        }
    } as NavTheme;

    if (color) {
        theme.palette.text.primaryHover = color;
        theme.palette.accent.text = color;
        theme.palette.accent.background = `radial-gradient(100% 185.14% at 100% 100%, ${from} 0%, ${to} 100%)`;
        theme.palette.accent.backgroundHover = to;
    }

    if (isFooter) {
        theme.palette.accent = {
            text: '#26bbff',
            background: '#26bbff',
            backgroundHover: '#338EEE',
            backgroundText: '#000'
        };
    }

    return theme;
};
